<template>
    <div class="loading-box" :class='{lodingShow:lodingButton}'>
        <div class="loding-center">
            <div class="loding-center-box">
                <div class="logoBox">
                </div>
                <div class="text-box">
                    <span>BLUE WHALE</span>
                </div>
                <div class="text-box">
                    <span>DIGITAL TECHNOLOGY</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Loading',
        data() {
            return {
                lodingButton: false
            }
        },
        hiddenLoading() {
            this.lodingButton = !this.lodingButton
        }
    }
</script>
<style scoped>
    .loading-box {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
        background: #000000;
        overflow: hidden;
        transition: all 1s;
    }

    .loding-center {
        position: relative;
        width: 100%;
        height: 100vh;

    }

    .loding-center-box {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .logoBox {
        height: 100px;
        width: 100px;
        background: #000000 url('../../assets/bluelogo.png') no-repeat center;
        background-size: 100%;
        animation: changeWH 2s forwards;
    }

    .text-box {
        overflow: hidden;
    }

    .text-box>span {
        color: #ffffff;
        font-size: 30px;
        display: block;
        animation: TextUp 2s forwards;
    }

    .text-box:last-child>span {
        font-size: 10px;
        letter-spacing: 2.8px;
    }

    /* 动画效果 */
    .lodingShow {
        height: 0vh;
    }

    @keyframes changeWH {
        from {
            -webkit-clip-path: circle(0% at 50% 50%);
            clip-path: circle(0% at 50% 50%);
        }

        to {
            -webkit-clip-path: circle(70.7% at 50% 50%);
            clip-path: circle(70.7% at 50% 50%);
        }
    }

    @keyframes TextUp {
        0% {
            opacity: 0;
            transform: translateY(100%);
        }

        50% {
            opacity: 1;
            transform: translateY(0%);
        }
    }

    @media(max-width: 995px) {
        .logoBox {
            height: 100px;
            width: 100px;
        }

        .text-box>span {
            font-size: 16px;
        }

        .text-box:last-child>span {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/base/loading.vue